<template lang="pug">
.info-miner.w100
  .result-payment-warning.notification.is-warning.has-text-left(v-if="disclaimer")
    span(v-html="disclaimer")
  .result-no-payments.pos-r.padding-no-results.has-text-left(v-if="!isLoading && list.length === 0")
    span You have no payouts, yet.
  table.table.is-fullwidth.table-payments
    tbody

      tr(
        v-for="item in list"
        :id="'payment_' + item.id"
        :class="{'animate-long': item.statusChanged}"
      ) 
        td 
          template(v-if="item.status === 'pending'")
            .pending-status
              span Payment in progress 
              i.fa.fa-circle-o-notch.fa-spin
          template(v-if="item.status === 'processing'")
            .processing-status
              span Processing payment...
          template(v-if="item.status === 'error'")
            template(v-if="item.reason === 'INVALID_ADDRESS'")
              .errored-status.color-error
                span Please check your worker(s), your address seems to be invalid! 
                span.hint--top-right.hint--medium(aria-label="Check your app or worker(s) for capitalization errors, then restart the mining process and retry the payment!")
                  i.fa.fa-question-circle
            template(v-else)
              .errored-status We couldn't process your payment, please try again!
          template(v-if="item.status === 'success'")
            .completed-status Payment completed

          span.w100.s12 {{ item.timestamp | formatDateSecond }} 
          span.w100.s12(v-if="isMultiChain")
            span ~ Via the 
            b.w400 {{ item.network }} 
            span chain

          span.w100.s12(v-if="item.tx && item.tx.indexOf('Internal') > -1")
            span ~ 
            span {{ item.tx }} 
              span.hint--top-right.hint--medium(:aria-label="'Payment sent directly through ' + item.exchange + '.'")
                i.fa.fa-question-circle

        td.amount 
          template(v-if="item.tx")
            template(v-if="item.tx.indexOf('Internal') === -1")
              a(
                :href="item.explorer_link"
                target="_blank"
                :class="{'error-style': item.status === 'error'}"
              ) {{ item.amount }}
            template(v-else)
              span(:class="{'error-style': item.status === 'error'}") {{ item.amount }}
          template(v-else)
            span(:class="{'error-style': item.status === 'error'}") {{ item.amount }}

  .bottom-controls-payments
    .page-switch.first.hint--bottom-right(
      v-if="hasPrev"
      aria-label="First page"
      @click="first"
    )
      button.button.is-small
        i.fa.fa-angle-double-left
    .page-switch.prev.hint--bottom-right(
      v-if="hasPrev"
      aria-label="Previous page"
      @click="prev"
    )
      button.button.is-small
        i.fa.fa-angle-left
    .page-switch.next.hint--bottom-left(
      v-if="hasNext"
      aria-label="Next page"
      @click="next"
    )
      button.button.is-small
        i.fa.fa-angle-right

</template>

<script>
import { apiGet } from '../util/general'
export default {
  name: 'c_tab_stats',
  props: ['uuid', 'isMultiChain'],
  data() {
    return {
      isLoading: false,
      list: [],
      page: 1,
      disclaimer: '',
      hasNext: false,
      hasPrev: false
    }
  },
  mounted() {
    let vm = this
    vm.fetch()
  },
  sockets: {
    connect() {
    },
    payment_status(data) {
      let vm = this
      for (var i = 0; i < vm.list.length; i++) {
        if (vm.list[i].id === data.id) {
          vm.list[i].status = data.status
          vm.list[i].tx = data.tx
          vm.list[i].explorer_link = vm.list[i].explorer + data.tx
          vm.list[i].statusChanged = true
          setTimeout(function () {
            vm.list[i].statusChanged = false
          }, 1310)
          break
        }
      }
    }
  },
  methods: {
    first() {
      let vm = this
      vm.page = 1
      vm.fetch()
    },
    next() {
      let vm = this
      vm.page = vm.page + 1
      vm.fetch()
    },
    prev() {
      let vm = this
      vm.page = vm.page - 1
      vm.fetch()
    },
    fetch() {
      let vm = this
      vm.isLoading = true
      vm.$emit('startLoading')

      let url = '/v5/account/' + vm.uuid + '/payments'
      if (vm.page > 1) url += '?page=' + (vm.page || 1)

      let obj = {}
      apiGet(vm, url, obj, function (data) {
        if (!data.success) {
          vm.$store.dispatch('notifyError', data.msg)
        } else {
          vm.disclaimer = data.data.disclaimer
          vm.hasNext = data.data.has_next
          vm.hasPrev = data.data.has_prev
          for (var i = 0; i < data.data.list.length; i++) {
            data.data.list[i].statusChanged = false
          }
          vm.list = data.data.list
        }
      }, function (err) {
        console.error('Error:', err.message)
        vm.$store.dispatch('notifyError', err.message)
      }, function () {
        vm.isLoading = false
        vm.$emit('stopLoading')
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.padding-no-results
  padding: 0px 0px 25px 10px
.error-style
  opacity:.4
.color-error
  color: #d18c0f !important

.table-payments
  td, th
    padding .4em .2em
  tr td
    vertical-align: middle
  td.amount
    font-size: 23px;
    text-align: right;
    font-weight: 100;
  
.table-payments.loading
  pointer-events: none;
  position relative
  &:before
    height 100%
    width 100%
    position: absolute
    opacity .7
    background-color: #fff
    content: ""
    top 0px
    left 0px
  &:after
    content: "Loading...";
    position: absolute;
    top: 50px;
    left: 0px;
    font-weight: 400;
    font-size: 15px
    width: 100%;
    text-align: center;

.top-controls-payments, .bottom-controls-payments
  position relative
  margin-bottom: 30px;

.page-switch
  display: inline-block;
  position: absolute;
  top: -4px;
  &.first
    left: 0px;
  &.prev
    left: 30px;
  &.next
    right: 0px;
</style>



// WEBPACK FOOTER //
// c_tab_payments.vue?125b44ee